import {
  GPS_FIX_MIN_MOVING_SPEED_KMH,
  LAP_DISTANCE_CHECK_MIN_MOVING_M,
  LAP_DISTANCE_TO_SPEED_RATIO,
} from '../../analysis/config/telemetryChecks'
import { KMH_PER_MPS } from '../../utils/speedUnits'
import { MS_PER_S } from '../../utils/timeUnits'
import type { LapCheck, LapCheckInput } from './lapReliability'

function movingDistances({ gpsPoints }: LapCheckInput) {
  let path = 0
  let bySpeed = 0
  for (let i = 1; i < gpsPoints.length; i++) {
    const [from, to] = [gpsPoints[i - 1], gpsPoints[i]]
    const seconds = (to.elapsedMs - from.elapsedMs) / MS_PER_S
    if (seconds <= 0) continue
    if (Math.min(from.speedKmh, to.speedKmh) < GPS_FIX_MIN_MOVING_SPEED_KMH)
      continue
    path += to.distanceMeters - from.distanceMeters
    bySpeed += ((from.speedKmh + to.speedKmh) / 2 / KMH_PER_MPS) * seconds
  }
  return { path, bySpeed }
}

const trustsTheDevicesSpeedAndClock = ({ diagnostics }: LapCheckInput) =>
  diagnostics?.gpsSpeedSource === 'device' &&
  diagnostics.gpsSpeedTrusted &&
  diagnostics.gpsTimeTrusted

export const distanceMatchesSpeed: LapCheck = {
  id: 'distanceMatchesSpeed',
  reason: 'gpsJump',
  isUnreliable(input) {
    if (!trustsTheDevicesSpeedAndClock(input)) return false
    const { path, bySpeed } = movingDistances(input)
    if (bySpeed < LAP_DISTANCE_CHECK_MIN_MOVING_M) return false
    const ratio = path / bySpeed
    return (
      ratio < LAP_DISTANCE_TO_SPEED_RATIO.min ||
      ratio > LAP_DISTANCE_TO_SPEED_RATIO.max
    )
  },
}
